import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MultipleSelectFilter } from '../../components/Filters';
import { changeValue } from '../../redux/actions/kitchenPlayerAction';
import { changeKHPSeveralValues } from '../../redux/actions/kitchenHistoryPlayerAction';
import useKitchenPlayerContext from './hooks/useKitchenPlayerContext';

const KitchenPlayerFilterEvents = ({ historyMode }) => {
  const dispatch = useDispatch();
  const { eventOptions } = useKitchenPlayerContext();
  const eventNames = useSelector(state => state.kitchenPlayer.eventNames);
  
  return (
    <MultipleSelectFilter
      title="Events"
      name="eventNames"
      options={eventOptions}
      values={eventNames}
      onChange={newEventNames => {
        dispatch(changeValue('eventNames', newEventNames));
        
        if (historyMode) {
          dispatch(changeKHPSeveralValues({
            pollingStartDate: null,
            pollingEndDate: null,
          }));
        }
      }}
    />
  );
};

export default KitchenPlayerFilterEvents;